import { createContext } from "react";

export const NotFoundContext = createContext();
